import React, { useState, useEffect, useRef } from 'react';
import { getFilteredUsers, GetUser } from '../isdlData/matrixUserData';
import { Pagination, Box, Modal } from '@mui/material';
import { MinimizeIcon1, AddIcon, EditIcon, EditIconDisabled } from '../icons/Icons';
import UserForm from './UserForm';
import AsyncSelect from 'react-select/async';

const ITEMS_PER_PAGE = 10; // Define how many items you want per page

function UserList({dbInitialized, UserChanged, Disabled, LoadedUser, HasEditPermission, BlockSelect = false, Placeholder = "Search for a user"}){

    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [error, setError] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [paginatedItems, setPaginatedItems] = useState([]);
    const [userFormVisible, setUserFormVisible]  = useState(false);
    const [addUserFormVisible, setAddUserFormVisible]  = useState(false);

    const inputRef = useRef(null);

    useEffect(() => {
        setLoading(!dbInitialized);

        return () => {
            //cleanup here
        };
    },[dbInitialized, Disabled, LoadedUser]);

    useEffect(() => {
        async function PrefillUser(){

            try{
                const user = (await GetUser(LoadedUser));
                const formUser = formatUserData(user);
                setSelectedUser(formUser); // Set as selected user
                UserChanged(user);
            }catch(e){
                console.log(LoadedUser + " user not found, ignoring");
            }
            
        }

        if(dbInitialized && (LoadedUser !== undefined && LoadedUser !== null && LoadedUser !== '')){
            PrefillUser();
        }

    },[LoadedUser]);

    useEffect(() => {
        handleUserSearch();
    },[searchTerm])

const handleUserChange = () => {
    UserChanged(selectedUser);
};

const handleUserClick = (user) => {
    setSelectedUser(user);
    UserChanged(user);
    handleCollapseList();
}

const handleUserSearch = async () =>{

    if(searchTerm.length === 0){
        setError('');
        return
    }

    if(searchTerm.length < 3){
        setError('You must input more than 3 characters to search for a User.');
        return;
    }

    setError('');
    setPage(1); // Reset page when making a new search
    setItems([]);

    try{
        const users = await getFilteredUsers(searchTerm);
        const result = Array.isArray(users) ? users : [users];

        if(result.length === 0){
            setError(`No users found with the name '${searchTerm}'`);
        }
        else if(result.length === 1){
            setSelectedUser(result[0]);
            handleUserClick(result[0]);
        } else {
            //show list
            setItems(result);
            setTotalPages(Math.ceil(result.length / ITEMS_PER_PAGE));
            handlePagenatedItems(result, 1);
        }


    } catch(ex){
        setError('Error fetching users.');
    }
};

const handleUserKeyDown = (e) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        handleUserSearch();
      }
}

const handleConfirm = () => {
    if (selectedUser) {
      console.log(`Confirmed item: ${selectedUser.FullName}`);
    }
  };

const handlePageChange = (event, value) => {
    setPage(value);
    handlePagenatedItems(items, value);
};

function handlePagenatedItems(fullItems, pageNum)
{
    const filteredItems = fullItems.slice(
        (pageNum - 1) * ITEMS_PER_PAGE,
        pageNum * ITEMS_PER_PAGE
    );
    setPaginatedItems(filteredItems);
}

const handleCollapseList = () => {
    setPage(1); // Reset page when making a new search
    setItems([]);
    setPaginatedItems([]);
}

const handleFocus = () => {
    inputRef.current.select();
}

const handleEditClick = () => {
    setUserFormVisible(true);
}

const handleAddClick = () => {
    setSelectedUser(null);
    UserChanged(null);
    setUserFormVisible(true);
}

const handleUserFormFinish = (data) =>{
    if(data === null){
        setUserFormVisible(false);
    }
    else
    {
        const formData = formatUserData(data);
        setSelectedUser(formData);
        setUserFormVisible(false);
        handleCollapseList();
        UserChanged(formData.data);
    }
}

const handleInputChange = (input) => {
        setSearchTerm(input);
    if(input.length < 3){
        handleCollapseList();
    }
}

function formatUserData(user){
    return {
        value: user.id,
        label: `${user.FullName} (${user.id})`,
        data: user, 
    }
}

const loadOptions = async (inputValue) => {
    if (inputValue.length < 3) return []; // Only search if input has 3 or more characters
    const results = await getFilteredUsers(inputValue); // Call your async search function
    const users = Array.isArray(results) ? results : [results];
    return users.map(user => ({
      value: user.id,
      label: `${user.FullName} (${user.id})`,
      data: user, // Attach full user data here for easy retrieval
    }));
  };

  const handleUserSelect = (selectedOption) => {
    if (selectedOption) {
      setSelectedUser(selectedOption); // Store the full user info
      UserChanged(selectedOption.data);
    } else {
      setSelectedUser(null); // Reset if no selection
      UserChanged(null);
    }
  };

    return(
<div>
    <div style={{display:'flex', flexDirection:'row', margin:'10px'}}>
{!Disabled && (
    <>
    <div style={{ flex:'1', marginRight:'10px'}}>
        <AsyncSelect
                id={"userSelector"}
                isDisabled={BlockSelect}
                cacheOptions
                loadOptions={loadOptions}
                defaultOptions
                placeholder={Placeholder}
                isClearable
                value={selectedUser} 
                onChange={handleUserSelect}
                classNamePrefix='search-input'
                menuPortalTarget={document.body}
                menuPosition='fixed'
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    option: (base, { isFocused, isSelected }) => ({
                      ...base,
                      backgroundColor: isFocused || isSelected ? getComputedStyle(document.documentElement).getPropertyValue('--selected-highlight') : getComputedStyle(document.documentElement).getPropertyValue('--input-background'),
                      color: isFocused || isSelected ? getComputedStyle(document.documentElement).getPropertyValue('--input-background') : getComputedStyle(document.documentElement).getPropertyValue('--input-background-invert'),
                    }),
                  }}
                />
    </div>
        
        {/* <input
            className='venue-search-input'
            style={{ flex:'1', marginRight:'10px'}}
            type="search"
            value={searchTerm}
            onChange={(e) => handleInputChange(e.target.value)}
            onKeyDown={handleUserKeyDown}
            placeholder='Search Users'
            disabled={Disabled || loading}
            ref={inputRef}
            onFocus={handleFocus}/> */}
            {/* <button 
                onClick={handleUserSearch} 
                disabled={Disabled || loading} 
                className='venue-search-button' 
                style={{width:'100px', flex:'0 0 auto'}}>Search</button> */}

        {/* {selectedUser && (
            <div className='venue-selected-div'>
                User Selected: {selectedUser.FullName + " (" + selectedUser.id + ")"}
            </div>
        )}

        {!selectedUser && (
            <div className='venue-selected-div'>
                No user selected.
            </div>
        )} */}


    <div style={{marginLeft:'auto', width:'auto', display:'flex', flexDirection:'row'}}>
            {paginatedItems.length > 1 && (
                <button
                style={{width:'40px', marginLeft:'auto', background:'transparent', border:'0px'}}
                onClick={handleCollapseList}>
                    <MinimizeIcon1/>
                </button>
            )}

            <button
                hidden={!HasEditPermission}
                style={{width:'40px', marginLeft:'auto', background:'transparent', border:'0px'}}
                onClick={handleAddClick}>
                <AddIcon/>
            </button>

            <button
                hidden={selectedUser === null || (selectedUser !== null && !HasEditPermission)}
                style={{width:'40px', marginLeft:'auto', background:'transparent', border:'0px'}}
                onClick={handleEditClick}>
                    {selectedUser === null && (
                        <>
                        <EditIconDisabled/>
                        </>
                    )}
                    {selectedUser !== null && (
                        <>
                        <EditIcon/>
                        </>
                    )}
            </button>
        </div>
        </>
)}
    </div>

    {/* {!Disabled && items.length > 1 && (
        <div>
            {paginatedItems.map((item) => (
                <div key={item.id + item.FullName}>
                <input
                    className='venue-item'
                    type="button"
                    name="selectedItem"
                    value={item.FullName + " (" + item.id + ")"}
                    disabled={selectedUser ? item.id === selectedUser.id : false}
                    onClick={() => handleUserClick(item)}
                />
                </div>
            ))}
            
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                variant='outlined'
                sx={{
                    "& .MuiPaginationItem-root": {
                      color: getComputedStyle(document.documentElement).getPropertyValue('--foreground-primary'),  // Set text color to white
                    },
                  }}
            />
            </Box>
        </div>
    )} */}

    {error && <div>{error}</div>}

    <Modal
        open={userFormVisible}>
            <UserForm User={selectedUser} FinishedChanging={handleUserFormFinish}/>
    </Modal>

</div>
    );
}

export default UserList;
